import React from "react";

// Se exporta para que eventSchema.js genere el FAQPage a partir de las
// mismas preguntas. Una sola fuente: el schema no se puede desincronizar
// de lo que el usuario ve en pantalla.
export const faqs = [
    {
        question: "¿Necesito registrarme?",
        answer: "Sí. El registro aparta tu cupo y te genera un código QR personal, que recibes por correo. Ese código es lo que permite que las instituciones que te interesen puedan contactarte después de la Conferencia: se lo muestras el día del evento y ellas reciben tus datos."
    },
    {
        question: "¿Tiene algún costo la entrada a la Conferencia?",
        answer: "La Conferencia es completamente gratuita. No se cobra la entrada ni nada durante el evento."
    },
    {
        question: "¿Puedo asistir con mi pareja, padres, hermanos o amigos?",
        answer: "¡Claro que sí! Te invitamos a venir acompañado. Solo ten en cuenta que cada persona que desee recibir información personalizada de las instituciones necesitará registrarse individualmente."
    },
    {
        question: "¿Cómo sé si este evento es para mí?",
        answer: "Si quieres estudiar, trabajar y migrar a Canadá con una estrategia clara y actualizada, este evento es para ti. Migrar a Canadá hoy no es igual que hace algunos años: aquí entenderás cuál es el mejor camino para tu perfil."
    },
    {
        question: "¿Podré hablar en persona con los expositores?",
        answer: "Sí. El evento tiene dos momentos: una conferencia con información actualizada sobre estudios, empleo y migración, y un espacio de atención uno a uno donde puedes acercarte a cada expositor a resolver tus dudas concretas."
    },
    {
        question: "¿Qué instituciones participan en esta Conferencia?",
        answer: "Contaremos con la presencia de instituciones educativas canadienses como Red River College Polytechnic, Assiniboine College, NAIT y Saskatchewan Polytechnic, ubicados en provincias estratégicas por su costo de vida accesible y sus programas de residencia permanente. Además estarán un asesor laboral especializado y un consultor migratorio regulado por el Gobierno de Canadá."
    },
    {
        question: "¿Qué debo llevar el día del evento?",
        answer: "Tres cosas: tu identificación oficial (INE o pasaporte), haberte registrado antes en la ciudad a la que vas a asistir, y el código QR que te llega por correo al registrarte. Ese QR es tu pase: se lo muestras a las instituciones que te interesen y ellas reciben tus datos para enviarte su información."
    },
    {
        question: "¿Dónde será la Conferencia?",
        answer: "La Conferencia llega a tres ciudades de México en octubre de 2026: Ciudad de México el día 6, Guadalajara el 8 y Monterrey el 10. Regístrate en la ciudad a la que vas a asistir, porque el cupo de cada sede es independiente."
    }
]

function Faqs() {
    return (
        <>
            <div className="accordion" id="faqsAccordion">
                {faqs.map((faq, index) => (
                    <div className="accordion-item" key={index}>
                        <h3 className="accordion-header" id={`heading${index}`}>
                            <button
                                className={`accordion-button ${index === 0 ? '' : 'collapsed'}`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${index}`}
                                aria-expanded={index === 0 ? 'true' : 'false'}
                                aria-controls={`collapse${index}`}
                            >
                                {faq.question}
                            </button>
                        </h3>
                        <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                            aria-labelledby={`heading${index}`}
                            data-bs-parent="#faqsAccordion"
                        >
                            <div className="accordion-body">
                                {faq.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </>
    );
}

export default Faqs;